// Bundle JavaScript pour le front public Rholala
// Présentation générale du service, pages d'accueil, marketing, etc.
// Ne contient PAS les profils (qui ont leur propre bundle profiles.js)

// Core Turbo pour la navigation
import "@hotwired/turbo-rails"

// Import sélectif des contrôleurs front
import { application } from "./controllers/application.js"

// ===== FRONT - PRÉSENTATION DU SERVICE =====
// Contrôleurs pour les pages marketing, accueil, contact, etc.

// Transitions générales pour le site
import PageTransitionController from "./controllers/front/page_transition_controller.js"
application.register("page-transition", PageTransitionController)

// Circle wipe — transition entre pages (home/landing/storytelling/explore)
import CircleTransitionController from "./controllers/shared/circle_transition_controller.js"
application.register("circle-transition", CircleTransitionController)

// ===== UI GÉNÉRAL =====
// Composants UI pour le front public

import ToastController from "./controllers/shared/ui/toast_controller"
application.register("toast", ToastController)

// Home animations (load cascade + scroll reveals)
import HomeAnimationsController from "./controllers/front/animations/home_animations_controller.js"
application.register("home-animations", HomeAnimationsController)

// Scroll doux vers un élément à sa connexion (résultat du test IA)
import ScrollIntoViewController from "./controllers/front/scroll_into_view_controller.js"
application.register("scroll-into-view", ScrollIntoViewController)

// ===== WEBMCP - DISCOVERY TOOL =====
// Expose un tool de recherche aux agents IA sur les pages explore
import WebmcpDiscoveryController from "./controllers/profiles/webmcp_discovery_controller.js"
application.register("profiles--webmcp-discovery", WebmcpDiscoveryController)

// ===== CONTACT =====
// Page contact plateforme
import ContactController from "./controllers/front/contact_controller.js"
application.register("front--contact", ContactController)

import RgpdResetController from "./controllers/front/rgpd_reset_controller"
application.register("rgpd-reset", RgpdResetController)

// ===== STORYTELLING - AI CONVINCE =====
// Boutons IA (Claude, ChatGPT, Perplexity, Gemini) sur les pages storytelling
import LandingAiButtonsController from "./controllers/landing_ai_buttons_controller.js"
application.register("landing-ai-buttons", LandingAiButtonsController)

import StoryAiToggleController from "./controllers/front/story_ai_toggle_controller.js"
application.register("story-ai-toggle", StoryAiToggleController)

// ===== WEBMCP - HELP CENTER =====
// Expose les tools Help Center aux agents IA sur /aide
import WebmcpHelpController from "./controllers/front/webmcp_help_controller.js"
application.register("front--webmcp-help", WebmcpHelpController)